import React, { useEffect, useState } from "react";
import "../../styles/admins/inventory.css";
import AddProduct from "./add_product";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FiSearch } from "react-icons/fi";

function AdminInventory(props) {
  const [toggleAdd, setToggleAdd] = useState(false);
  const [products, setProducts] = useState([]);
  const [editProd, setEditProd] = useState({});
  const [showUpload, setShowUpload] = useState(false);
    const [excelFile, setExcelFile] = useState(null);
const [searchTerm, setSearchTerm] = useState("");


function addProductToggler() {
  setToggleAdd(prev => !prev);

  // if (toggleAdd) {
  //   getProducts(true);
  // }
}


  function makeDDMMMYYYY(date) {
    const day = date.getDate().toString().padStart(2, "0"); // Ensure two digits
    const month = date.toLocaleString("en-US", {
      month: "short",
    }); // Get short month name
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const calculateExpiryDate = (purchaseDate, monthsToAdd) => {
    if (!purchaseDate || !monthsToAdd) return "N/A";
    let date = new Date(purchaseDate);
    date.setMonth(date.getMonth() + parseInt(monthsToAdd, 10));

    return makeDDMMMYYYY(date);
  };


      const getProducts = async (forceFetch = false) => {
      try {
        const storedProducts = localStorage.getItem("products");

        if (storedProducts) {
                    if(props.clientData.is_admin == 'Techie'){
 const filtered = JSON.parse(storedProducts).filter(
    (product) => product.added_by == props.clientData.company_id
  );

  setProducts(filtered);
                    }
                    else {
          setProducts(JSON.parse(storedProducts));
                    }
        } else {
          const response = await axios.get(
            "https://api.dectwinservices.com/api/products"
          );

          if(props.clientData.is_admin == 'Techie'){
     
const filterData = response.data.filter(product => product.added_by == props.clientData.company_id);
            setProducts(filterData);


          localStorage.setItem("products", JSON.stringify(response.data));
          }
          else {
          setProducts(response.data);
          localStorage.setItem("products", JSON.stringify(response.data));
          }
        }
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };

  useEffect(() => {
    getProducts();
  }, [props]);

  useEffect(() => {
  if (!toggleAdd) {
    getProducts(true);
  }
}, [toggleAdd]);




  const exportToExcel = () => {
    if (!products || products.length === 0) {
      console.error("No data to export.");
      return;
    }

    // Define the columns for the Excel file
    const formattedData = products.map((item) => ({
      "Product Name": item.name,
      Barcode: item.barcode,
      Category: item.category,
      "Sub-Category": item.sub_category,
      "Serial Number": item.serial_no,
      "Availability Status": item.stats,
      "Purchase Date": makeDDMMMYYYY(new Date(item.pur_date)),
      "Expiry Date": calculateExpiryDate(item.pur_date, item.expiry_date),
      Version: item.vers_proc,
      RAM: item.key_ram,
      "SSD/HDD": item.ssd_hdd,
      Processor: item.processor,
      "License Type": item.lic_type_storage,
      "MAC Address": item.mac_no_users,
      "Make By": item.user_name,
      Remarks: item.remarks,
      "Added By": item.company_name,
      "Assigned To": item.assigned_staff_name,
      "Assigned Staff Id": item.assigned_staff_id
    }));

    // Create a new worksheet
    const ws = XLSX.utils.json_to_sheet(formattedData);

    // Create a new workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Products");

    // Convert workbook to a binary Excel file
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    // Create a Blob and trigger download
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `Products.xlsx`);
  };


const handleExcelUpload = async (e) => {
  e.preventDefault();
  if (!excelFile) return;

  const uploadFormData = new FormData();
  uploadFormData.append('file', excelFile);

  // Conditionally add `added_by`
  const addedBy = props.clientData?.is_admin == null 
    ? null 
    : props.clientData.company_id;

  uploadFormData.append('added_by', addedBy);

  try {
    const response = await fetch('https://api.dectwinservices.com/api/upload-product-data', {
      method: 'POST',
      body: uploadFormData
    });

    const data = await response.json();

    if (response.ok) {
      setShowUpload(false);
      props.handleToast({
        toastMsg: "Inventory uploaded Successfully.",
        toastColor: "#4CAF50",
      });
      window.location.reload();
    } else {
      props.handleToast({
        toastMsg: "Something went wrong! Please check data or internet.",
        toastColor: "#FF0000",
      });
    }
  } catch (error) {
    console.error('Upload error:', error);
  }
};


const filteredProducts = products.filter((p) =>
  p.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  p.serial_no.toLowerCase().includes(searchTerm.toLowerCase()) ||
    p.category.toLowerCase().includes(searchTerm.toLowerCase())
);

  return toggleAdd ? (
    <AddProduct
      editProd={editProd}
      clientData={props.clientData}
      toggler={addProductToggler}
      handleToast={props.handleToast}
      handleLoading={props.handleLoading}
      closeLoading={props.closeLoading}
    />
  ) : (
    <section className="px-32">
      <div className="d-md-flex justify-between">
        <div className="d-flex">
          <i className="bx bxs-customize" style={{ fontSize: "24px" }}></i>
          <p className="fw-bolder fs-big">&nbsp;Product's Inventory</p>
        </div>
     
     

<div className="d-md-flex d-sm-flex">


          <div className="my-2 px-1">           <button
            className="add-btn"
            style={{ background: "brown" }}
            onClick={() => setShowUpload(true)}
          >
            <i className="bx bxs-file" style={{ fontSize: "22px" }}></i>
            &nbsp; Upload Products
          </button>
          </div>

       <div className="my-2 px-1">    <button
            className="add-btn"
            style={{ background: "#00AA00" }}
            onClick={exportToExcel}
          >
            <i className="bx bxs-download" style={{ fontSize: "22px" }}></i>
            &nbsp; Export to Excel
          </button>
     </div>
     
      <div className="my-2 px-1">     <button
            className="add-btn"
            onClick={() => {
              setEditProd({});
              addProductToggler();
            }}
          >
            <i className="bx bxs-plus-circle" style={{ fontSize: "22px" }}></i>
            &nbsp; Add Product
          </button>
          </div>
        </div>
      </div>

  <div className="form-data col-md-4 col-12">
      <div className="input-icon bg-white">
        <i className="bx bxs-search"></i>

      <input
        type="text"
        className="p-2"
        placeholder="Search by name"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  </div>

       <div className="bg-white table-responsive rounded-3">
        <table className="table w-100">
                   <thead className="bg-grey">
           
              {props.clientData.is_admin == null && (
                              <th className="p-2">Assigned To</th>
              )}
              <th className="p-2">Serial No</th>
              <th className="p-2">Product Name</th>
              <th className="p-2">Make By</th>
              <th className="p-2">Category</th>
              <th className="p-2">Status</th>
              <th className="p-2">Validity</th>
              {props.clientData.is_admin == null && (
                              <th className="p-2">Added By</th>
              // <th style={{flex: 1}}>Assigned To</th>
              )
}

  <th className="p-2">Created On</th>
              <th   className="p-2 text-center">
                <i className="bx bxs-cog rounded-circle bg-grey p-0"></i>
              </th>
          </thead>

    
              {filteredProducts.map((prods, index) => {
                return (
                  <tr key={index}>
                                                      {props.clientData.is_admin == null && (
                                    <>
                    <td className="p-2">{prods.assigned_staff_name || "IT Stock"}</td>
                                                        </>
)}
                    <td className="p-2">{prods.serial_no}</td>
                    <td className="p-2">{prods.name}</td>
                    <td className="p-2">{prods.user_name}</td>
                    <td className="p-2">{prods.category}</td>
                    <td className="p-2">{prods.stats}</td>
                    <td className="p-2">
                      {calculateExpiryDate(prods.pur_date, prods.expiry_date)}
                    </td>
                                  {props.clientData.is_admin == null && (
                                    <>
                    <td className="p-2">{prods.added_by == null ? 'Admin' : prods.company_name}</td>
               
                                                        </>
)}

  <td className="p-2">{prods.created_date}</td>
                    <td className="p-2">
                      <i
                        title="Edit Product"
                        style={{ fontSize: "24px", cursor: "pointer" }}
                        className="bx bxs-edit"
                        onClick={() => {
                          setEditProd(prods);
                          addProductToggler();
                        }}
                      ></i>
                   
                    </td>
                  </tr>
                );
              })}
          </table>
      </div>

      {showUpload && (
    <div className="ticket-popup">
      <div className="accept-ticket">
        {/* Left Side - Product Details */}
        <h2 style={{ textAlign: "center", marginTop: "0" }}>Upload Product's Inventory</h2>


  <form className="my-4" onSubmit={handleExcelUpload}>
    <div className="form-data">
      <label htmlFor="excelFile">Upload Excel File</label>
            <div className="input-icon">
      <input
        type="file"
        id="excelFile"
        accept=".xlsx, .xls"
        onChange={(e) => setExcelFile(e.target.files[0])}
        required
      />
</div>    </div>

<br />
            <div className="btn-group d-flex" style={{ justifyContent: "center" }}>
          <button
            className="add-btn"
            style={{ background: "#ec0e0e" }}
            onClick={() => setShowUpload(false)}
          >
            Go Back
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <button className="add-btn">
            Submit
          </button>
        </div>

  </form>



        </div>
        </div>
      )}

    </section>
  );
}

export default AdminInventory;
